exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.dmb-web__OtherImageryVendor__vendor__2ioBy {\n  color: #656565;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 20px;\n  padding: 15px 18px;\n}\n", ""]);

// exports
exports.locals = {
	"vendor": "dmb-web__OtherImageryVendor__vendor__2ioBy"
};